import { FetchMarketingContactsRequestTypes } from '../actions/MarketingContactsActions';
const MarketingContacts = (state = {
  onMCRenewal: 0,
  onSwitchToMC: 0
}, {
  type,
  payload
}) => {
  switch (type) {
    case FetchMarketingContactsRequestTypes.RECEIVE:
      {
        const [{
          total: marketingContactsOnMCRenewal
        }, {
          total: marketingContactsOnSwitchToMC
        }] = payload.data;
        return {
          onMCRenewal: marketingContactsOnMCRenewal,
          onSwitchToMC: marketingContactsOnSwitchToMC
        };
      }
    default:
      return state;
  }
};
export default MarketingContacts;